export type RawPlausibleGoalTotals = {
  goal?: string
  date_range?: string
  site_source?: string
  site_count?: number
  successful_site_count?: number
  failed_site_count?: number
  total_form_submissions?: number
  total_unique_visitors?: number
  total_visits?: number
  average_bounce_rate?: number
  total?: number
  last_synced_at?: string
  status?: string
}

export type PlausibleGoalTotals = {
  goal?: string
  dateRange?: string
  siteSource?: string
  siteCount?: number
  successfulSiteCount?: number
  failedSiteCount?: number
  totalFormSubmissions: number
  totalUniqueVisitors?: number
  totalVisits?: number
  averageBounceRate?: number
  total: number
  lastSyncedAt?: string
  status?: string
}

function cleanString(value: unknown) {
  if (typeof value !== 'string') return undefined

  const trimmed = value.trim()
  return trimmed || undefined
}

function cleanNumber(value: unknown) {
  return typeof value === 'number' && Number.isFinite(value) ? value : undefined
}

export function normalizePlausibleGoalTotals(input: RawPlausibleGoalTotals): PlausibleGoalTotals {
  const totalFormSubmissions = cleanNumber(input.total_form_submissions) ?? cleanNumber(input.total) ?? 0

  return {
    goal: cleanString(input.goal),
    dateRange: cleanString(input.date_range),
    siteSource: cleanString(input.site_source),
    siteCount: cleanNumber(input.site_count),
    successfulSiteCount: cleanNumber(input.successful_site_count),
    failedSiteCount: cleanNumber(input.failed_site_count),
    totalFormSubmissions,
    totalUniqueVisitors: cleanNumber(input.total_unique_visitors),
    totalVisits: cleanNumber(input.total_visits),
    averageBounceRate: cleanNumber(input.average_bounce_rate),
    total: cleanNumber(input.total) ?? totalFormSubmissions,
    lastSyncedAt: cleanString(input.last_synced_at),
    status: cleanString(input.status),
  }
}
